module.exports = __webpack_public_path__ + "dfdbbad040f010c077ddadfb0addc007.png";